import { Map as MapIcon } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.06 — sitemap.xml boshqaruvi. Sitemap yozuvlari (URL + o'zgarish chastotasi +
 * prioritet) ro'yxati; qo'shish/o'chirish `/admin/seo/sitemap` ga (fail-soft).
 */
export function SitemapScreen() {
  return (
    <SeoConfigTable
      screenId="A12.06"
      title={S.sitemap}
      addLabel={S.addSitemap}
      path="/admin/seo/sitemap"
      listKey="entries"
      searchKeys={['loc']}
      icon={<MapIcon size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'loc', placeholder: 'https://mygram.my/page', mono: true },
        {
          name: 'changefreq',
          placeholder: S.changefreq,
          options: [
            { value: 'always', label: 'always' },
            { value: 'hourly', label: 'hourly' },
            { value: 'daily', label: 'daily' },
            { value: 'weekly', label: 'weekly' },
            { value: 'monthly', label: 'monthly' },
            { value: 'yearly', label: 'yearly' },
            { value: 'never', label: 'never' },
          ],
        },
        { name: 'priority', placeholder: '0.8', mono: true },
      ]}
      columns={[
        { key: 'loc', header: S.loc, type: 'text' },
        { key: 'changefreq', header: S.changefreq, type: 'text' },
        { key: 'priority', header: S.priority, type: 'text' },
      ]}
    />
  )
}
